import React, { FC } from "react";
import { useNetworkState } from "../../../hooks/useNetworkState";
import { useDatabaseStatus } from "../../../hooks/database/useDatabaseStatus";
import { useCurrentProject } from "../../../hooks/database/useCurrentProject";
import { useCurrentInventory } from "../../../hooks/database/useCurrentInventory";

export const StatusBar: FC = () => {
  const { state } = useNetworkState();
  const { syncing, dirty, dirtyInventories } = useDatabaseStatus();

  const { data: project } = useCurrentProject();
  const { data: inventory } = useCurrentInventory();

  return (
    <div id="status">
      <div>
        <span>
          {state === "online" ? (
            <i className="fa fa-link" />
          ) : state === "online-slow" ? (
            <i className="fa fa-hourglass-o" /> // TODO: better icon
          ) : state === "online-blocked" ? (
            <i className="fa fa-pause" />
          ) : (
            <i className="fa fa-chain-broken" />
          )}
        </span>
        {syncing ? (
          <span>
            &nbsp;&mdash;&nbsp;
            <i className="fa fa-refresh fa-spin" />
          </span>
        ) : null}
        {dirty || dirtyInventories.length > 0 ? (
          <span>
            &nbsp;&mdash;&nbsp;
            <i className="fa fa-floppy-o" />
          </span>
        ) : null}
      </div>
      {project || inventory ? (
        <div>
          &nbsp;&mdash;&nbsp;
          {project?.name}
          {project && inventory ? " / " : ""}
          {inventory?.name}
        </div>
      ) : null}
      <div></div>
    </div>
  );
};
